export default __webpack_public_path__ + "static/spiritual-christian-shrines-4-a3e6c931e4c7b3bccd0c72b59d653289.jpg";